var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1739 0.666748C5.97818 0.666748 0.138184 6.64008 0.138184 14.0001C0.138184 21.3601 5.97818 27.3334 13.1739 27.3334C20.3696 27.3334 26.2096 21.3601 26.2096 14.0001C26.2096 6.64008 20.3696 0.666748 13.1739 0.666748ZM10.5668 20.6667L4.0489 14.0001L5.88693 12.1201L10.5668 16.8934L20.4609 6.77341L22.2989 8.66675L10.5668 20.6667Z",
    fill: "#3AB084"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.8b457b511728ad3b57d2d3aa9a0fd27a.svg";
export { ForwardRef as ReactComponent };